import * as yup from "yup";
import { PHONE_REGEXP } from "../../../../lib/globals";

export const profileFormSchema = yup.object().shape(
    {
        id: yup.number().required(),
        firstName: yup.string().required("First Name is required"),
        lastName: yup.string().required("Last Name is required"),
        address: yup.string().required("Street Address is required"),
        address2: yup.string().optional(),
        city: yup.string().required("City is required"),
        state: yup
            .string()
            .max(2, "Please enter your state's abbreviation (WI, IL, etc)")
            .required("Please specify the state your team is from"),
        zipCode: yup
            .string()
            .matches(
                /^\d{5}(-\d{4})?$/,
                "ZIP Code must be in the format ##### or #####-####",
            )
            .required("Zip Code is required"),
        dob: yup
            .string()
            .required("Date of Birth is required")
            .typeError("Invalid date of birth provided")
            .matches(
                /^\d{1,2}\/\d{1,2}\/\d{4}$/,
                "Date of Birth must be in mm/dd/yyyy format",
            )
            .test("is-valid-dob", "Invalid date of birth provided", dob => {
                if (!dob) return true;
                return !isNaN(new Date(dob).getTime());
            }),
        ssn: yup
            .string()
            .matches(/^\d{3}-\d{2}-\d{4}$/, "SSN must be in ###-##-#### format")
            .required("SSN is required"),
        gender: yup
            .object()
            .shape({
                value: yup.string().required("Gender is required"),
                label: yup.string().required("Gender is required"),
            })
            .required("Gender is required"),
        race: yup
            .object()
            .shape({
                value: yup.string().required("Race is required"),
                label: yup.string().required("Race is required"),
            })
            .required("Race is required"),
        email: yup
            .string()
            .required("Email is required")
            .email("Email is invalid"),
        password: yup.string().when("password", {
            is: "",
            then: schema =>
                schema
                    .transform((value, originalValue) => {
                        if (!value) {
                            return null;
                        }
                        return originalValue;
                    })
                    .nullable()
                    .optional(),
            otherwise: schema =>
                schema.min(
                    8,
                    "Password length should be at least 8 characters",
                ),
        }),
        confirmPassword: yup.string().when(["password", "confirmPassword"], {
            is: "",
            then: schema =>
                schema
                    .transform((value, originalValue) => {
                        if (!value) {
                            return null;
                        }
                        return originalValue;
                    })
                    .nullable()
                    .optional(),
            otherwise: schema =>
                schema
                    .min(8, "Password length should be at least 8 characters")
                    .oneOf([yup.ref("password")], "Passwords do not match"),
        }),
        phone: yup
            .string()
            .required("Phone number is required")
            .matches(PHONE_REGEXP, "Phone number is not valid"),
    },
    [
        ["password", "password"],
        ["confirmPassword", "password"],
        ["confirmPassword", "confirmPassword"],
    ],
);
